var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeedingLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0H0V20H20V0ZM14.4524 6.60926C14.8591 6.23172 15.1204 6.5325 15.1755 6.86441C15.4878 8.94846 15.2253 10.8566 14.649 12.3866C14.2329 13.3594 13.3354 14.7262 12.0374 14.7575C11.3362 14.8046 10.1015 13.9185 10.9014 11.4523C11.5258 9.55071 12.84 8.07456 14.4524 6.60926ZM6.19773 9.8724C5.91691 9.68709 5.51865 9.67416 5.51893 10.229C5.4967 12.4077 5.68515 14.3751 6.65473 16.1259C7.91878 18.3896 9.40818 18.0872 9.85047 17.5409C10.7104 16.5682 10.3185 14.9804 9.88825 14.0138C9.15846 12.5508 7.9381 11.0607 6.19773 9.8724ZM7.67224 2.4521C7.81101 1.91482 8.19332 2.0273 8.41874 2.27703C9.80579 3.86357 10.6138 5.61198 10.9537 7.21121C11.128 8.25477 11.1095 9.89004 10.0332 10.6162C9.46816 11.0342 7.95048 10.9538 7.29402 8.44561C6.79416 6.5076 7.10475 4.55566 7.67224 2.4521Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedingLayer);
export default __webpack_public_path__ + "static/media/SeedingLayer.77de59d9f96d2be5c0d902a5c5dcdb0a.svg";
export { ForwardRef as ReactComponent };